import { useAuthContext } from '@aibees/shared/auth';
import { UserRelation } from '@aibees/shared/definition';
import { useWorkspaceUsers } from '@aibees/shared/workspace';

export function useGetOwnership(owner?: UserRelation) {
  const users = useWorkspaceUsers(true);
  const { user } = useAuthContext();

  const items = users.map((x) => ({
    label: `${x?.firstName} ${x?.lastName} ${x.current ? `(You)` : ``}`,
    value: x.id,
  }));
  const ownerName = owner
    ? `${owner.firstName} ${owner.lastName} ${
        user?.id === owner.id ? `(You)` : ``
      }`
    : 'No Body';
  const defaultCurrentItem = items.find((item) => item.value === owner?.id);
  const options = items.sort((a, b) => {
    if (a.value === defaultCurrentItem?.value) return -1;
    if (b.value === defaultCurrentItem?.value) return 1;
    return 0;
  });

  return { options, ownerName, users, defaultCurrentItem };
}

export function isCurrentOwnership(id?: string, currentId?: string) {
  return id === currentId;
}
